var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.158,
    height: 18,
    viewBox: "0 0 23.158 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_65eb9eeb2654c423bf71c6fe55b716ce",
    "data-name": "65eb9eeb2654c423bf71c6fe55b716ce",
    d: "M1,13.026v5.263a1.053,1.053,0,0,0,1.053,1.053H3.105a3.158,3.158,0,0,0,6.316,0h6.316a3.158,3.158,0,0,0,6.316,0h1.053a1.053,1.053,0,0,0,1.053-1.053V7.658A3.158,3.158,0,0,0,21,4.5H11.526A3.158,3.158,0,0,0,8.368,7.658v.105H6.263A3.158,3.158,0,0,0,3.737,9.026L1.211,12.395a.642.642,0,0,0-.074.147l-.063.116A1.053,1.053,0,0,0,1,13.026Zm16.842,6.316a1.053,1.053,0,1,1,1.053,1.053A1.053,1.053,0,0,1,17.842,19.342ZM10.474,7.658a1.053,1.053,0,0,1,1.053-1.053H21a1.053,1.053,0,0,1,1.053,1.053v9.579h-.821a3.158,3.158,0,0,0-4.674,0H10.474ZM8.368,11.974H4.158l1.263-1.684a1.053,1.053,0,0,1,.842-.421H8.368ZM5.211,19.342a1.053,1.053,0,1,1,1.053,1.053A1.053,1.053,0,0,1,5.211,19.342ZM3.105,14.079H8.368v2.926a3.158,3.158,0,0,0-4.442.232H3.105Z",
    transform: "translate(-1 -4.5)",
    fill: "#b3b3b3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipIcon);
export default __webpack_public_path__ + "static/media/ship_icon.588f14acd8a0333b4531b82268cc5acc.svg";
export { ForwardRef as ReactComponent };